import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'app-generatedMappingFile',
    template: `
  <a (click)="downloadtestResult($event)" style="color: cornflowerblue;text-decoration: underline;">{{downloadtestResults}}</a>`,
    standalone: false
})
export class DownloadTestResult implements ICellRendererAngularComp {

  params;
  label: string;
  migrationId
  downloadtestResults
  agInit(params): void {
    this.params = params;
    this.label = this.params.label || null;
    console.log(this.params);
    this.migrationId=this.params.data.migrationId;
    var downloadtestResult = this.params.data.testResult
    if (downloadtestResult == null || downloadtestResult == undefined || downloadtestResult == ''){

    }else {
      this.downloadtestResults = downloadtestResult.split('/').pop()
    }

    console.log(this.migrationId);
  }

  refresh(params?: any): boolean {
    return true;
  }

  downloadtestResult($event) {
    if (this.params.downloadtestResult instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data
        // ...something
      }
      console.log(params)
      this.params.downloadtestResult(params);

    }
  }
}
